import { Switch3Props } from '../../core/Switch3'
import { FormControlLabel } from '../../form'
import { styled } from '../../styles'

// Added font styles manually to fix build issue. Will fix this later

export const StyledLabelText = styled('p')(({ theme }) => ({
  fontFamily: 'Inter, sans-serif',
  fontSize: 14,
  lineHeight: '20px',
  fontWeight: 500,
  letterSpacing: 0,
  color: theme.palette.neutralGrey[1300],
  margin: 0,
  marginLeft: -10, // Component base width/2 (10px)
}))

export const StyledLabelTextSwitch3 = styled(FormControlLabel)<Switch3Props>(({ size, theme }) => ({
  '& .OSUI-FormControlLabel-label': {
    ...(size === 'small' && { fontSize: '14px', lineHeight: '20px' }),
    ...((!size || size === 'medium') && { fontSize: '16px', lineHeight: '24px' }),
  },
  fontWeight: 400,
}))
